import { api } from "../apis/configs/axiosConfigs";

export const setupAuthInterceptor = async getAccessTokenSilently => {
  const requestInterceptor = api.interceptors.request.use(
    async config => {
      let token;
      try {
        token = await getAccessTokenSilently();
      } catch (error) {
        localStorage.clear();
        // window.location.reload();
        window.location.href = "/";
      }
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  return () => {
    api.interceptors.request.eject(requestInterceptor);
  };
};
